export interface EmvDevice {
    id?: ID;
    computer?: {
        id: ID | null;
        label: string | null;
    };

    label: string;
    registrationCode: string;
    remoteId?: string;
    type: EmvDeviceType;
}

export enum EmvDeviceType {
    VERIFONE = "verifone",
    BBPOS = "bbpos",
}
